import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // <--- THIS LINE IS CRITICAL
import App from './App';
import './utils/axiosSetup';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
